<template>
  <div v-if="overview" class="card-page d-flex flex-column">
    <div class="card flex-grow-0">
      <div class="card-body">
        <div class="row">
          <div class="col-1">
            &nbsp;
          </div>
          <div class="col ml-3 text-center">
            <p class="h2"><span class="text-secondary h3">Bolagskompass för</span> {{overview.NAME}}</p>
          </div>
          <div class="col-1">
            &nbsp;
          </div>
        </div>
      </div>
    </div>

    <div v-if="ranking" class="card mt-2 flex-grow-1">
      <div class="card-body">
        <div class="row py-2">
          <div class="col-7" style="border-right: 1px solid lightgray;">
            <Compass :rankings="ranking" :years="1" :showBransch="true" />
          </div>
          <div class="col-5">
            <div class="ml-5" style="font-size: 1.2rem;">
              <div class="pl-2 pt-2" style="font-size: 1.5rem; font-weight: 300; color: black; position: relative;">
                <I name="compass2" class="cSecondary" style="font-size: 2.4rem; position: absolute; top: 10px; left: -50px;"/>
                Bedömning
              </div>
              <div class="p-2" style="font-weight: 700; font-size: 1.5em">
                {{ranking1.ranks.score}} av 400 poäng
              </div>
              <div class="pl-2 pt-2" style="font-size: 1.5rem; font-weight: 300; color: black; position: relative;">
                <I name="intersect" class="cSecondary" style="font-size: 2.4rem; position: absolute; top: 10px; left: -50px;"/>
                Sammanfattning
              </div>
              <div class="p-2" style="font-weight: 600; font-size: 1.25em">
                <pre>{{ranking1.analysis}}</pre>
              </div>
              <div class="pl-2 pt-2" style="font-size: 1.5rem; font-weight: 300; color: black; position: relative;">
                <I name="bubble" class="cSecondary" style="font-size: 2.4rem; position: absolute; top: 10px; left: -50px; transform: scaleX(-1);"/>
                Kommentar
              </div>
              <div class="p-2" style="font-weight: 600; font-size: 1.25em">
                <pre>{{ranking1.comment}}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { Component, Vue } from 'vue-property-decorator';
    import user from '@/store/modules/user';
    import CompanyMixin from '@/mixins/CompanyMixin';

    @Component({mixins: [CompanyMixin]})
    export default class CardCompass extends Vue {
    }
</script>

<style scoped>
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;
  }
</style>
